export default __webpack_public_path__ + "img/landscape_1.530d4d7fc67b507248c29d3e13700a7d.jpg";